import React from "react";
import {Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { updateStatusNotification,fetchNotifications } from "appRedux/actions/Notifications";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
    }

    showModal = () => {
      this.setState({
        visible: true,
      });
    };

 

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La notificación se ha procesado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al procesar la notificación.',
      });
    }
  };
  
 
  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash"/></Button>
        <Modal
          okText = "Borrar"
          cancelText = "Salir"
            title="Borrar"
            visible={this.state.visible}
            onOk={() => {
              //console.log(this.props.recording.id);
              this.props.updateStatusNotification(this.props.recording.id, () => { this.props.fetchNotifications(this.props.dateState ); });
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchNotifications();
              this.setState({visible: false});
            }}
          >
          <p>Está seguro de eliminar la notificacion?</p>
        </Modal>
      </div>
    );
  }
}


function mapStateToProps({notifications}) {
  return {
    notifications
  }
}
export default connect(mapStateToProps, {fetchNotifications, updateStatusNotification} )(ModalDelete);






// WEBPACK FOOTER //
// ./src/routes/main/Notification/ModalDelete.js